import { useCallback, useEffect, useState } from "react";
import { membersState } from "../../../store/atom";
import { useRecoilState } from "recoil";
import {
  createMember,
  deleteMember,
  getMembers,
  updateMemberOrder,
  updateMember,
} from "../../../api/members";
import styled from "styled-components";
import UpIcon from "../../../components/icons/UpIcon";
import DownIcon from "../../../components/icons/DownIcon";
import { ReactComponent as SearchIcon } from "../../../assets/icons/search.svg";
import MobileCreateMemberModal from "../../../components/mobile/MobileCreateMemberModal";
import MobileConfirmDeleteModal from "../../../components/mobile/MobileConfirmDeleteModal";
import ResetIcon from "../../../components/icons/ResetIcon";


const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 16px;
  margin-bottom: 100px;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;

  @media (max-width: 440px) {
    flex-wrap: wrap;
  }
`;

export const OrderButtonContainer = styled.div`
  display: flex;
  align-items: center;
  line-height: 24px;
  gap: 10px;

  > span {
    line-height: 24px;
  }
`;

const SelectedMemberContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
  font-size: 1.4rem;

  > p {
    font-weight: bold;
    color: #2aa4d5;
    min-width: 50px;
  }
`;

const OrderChangeContainer = styled.div`
  display: flex;
  align-items: center;
  gap:5px;
  font-size: 1.4rem;

  > span {
    min-width: 50px;
  }
`;

const OrderButtonWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const OrderButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3C3E45;
  transition: all 0.3s ease;
  padding: 2px;
  border-radius: 50%;
  
  &:hover {
    color: var(--primary-c);
  }
  
`;

const OrderButtonUpImg = styled.img`
  position: absolute;
  top: 6px;
  left: 7px;
  width: 15px;
  height: 15px;
`;
const OrderButtonDownImg = styled.img`
  position: absolute;
  top: 9px;
  left: 7.5px;
  width: 15px;
  height: 15px;
`;

const WriteButton = styled.button`
  display: inline-block;
  width: 100px;;
  height: 40px;
  background-color: #2aa4d5;
  color: #fff;
  font-weight: 700;
  text-align: center;
  border-radius: 12px;
  transition: background-color 0.3s ease;
  font-size: 1.4rem;

  &:hover {
    background-color: var(--primary-c-hover);
  }
`;

const TableContainer = styled.section`
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const TableEl = styled.table`
  width: 100%;
  border-top: 3px solid #2aa4d5;
  border-bottom: 2px solid #cfd0d1;
`;

const TableHead = styled.thead`
  background-color: #d4ecf7;
  font-size: 14px;
  font-weight: 700;
  color: #2c3e50;
`;

const TableBody = styled.tbody`
  font-size: 14px;
  font-weight: 400;
  color: #4e4e4e;
`;

const TableRowEl = styled.tr`
  display: flex;
  border-bottom: 1px solid #e5e5e5;

  &:last-child {
    border-bottom: none;
  }
`;

const TableBodyRow = styled(TableRowEl)`
  min-height: 56px;
  &:hover {
    background-color: rgba(234, 234, 234, 0.7);
  }
`;

const TableHeadItem = styled.th`
  padding: 14px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #e5e5e5;
`;

const TableHeadItemNo = styled(TableHeadItem)`
  min-width: 45px;
`;

const TableHeadItemPosition = styled(TableHeadItem)`
  min-width: 80px;
`;

const TableHeadItemName = styled(TableHeadItem)`
  min-width: 60px;
`;

const TableHeadItemRole = styled(TableHeadItem)`
  min-width: 150px;

  @media (max-width: 440px) {
    display: none;
  }
`;

const TableHeadItemEmail = styled(TableHeadItem)`
  flex: 1;
  min-width: 150px;
`;

const TableHeadItemManage = styled(TableHeadItem)`
  min-width: 100px;
  justify-content: center;

  @media (max-width: 440px) {
    min-width: 80px;
  }
`;

const TableBodyItem = styled.td`
  display: flex;
  align-items: center;
  padding: 8px;
`;

const TableEmptyMessage = styled(TableRowEl)`
  justify-content: center;
  padding: 20px;
`;

const TableBodyItemNo = styled(TableBodyItem)`
  min-width: 45px;
  justify-content: center;
  font-weight: 500;
`;

const TableBodyItemPosition = styled(TableBodyItem)`
  min-width: 80px;
  text-align: center;
  justify-content: center;
  span {
    cursor: pointer;
  }
`;

const TableBodyItemName = styled(TableBodyItem)`
  min-width: 60px;
  justify-content: center;
  font-weight: 600;
`;

const TableBodyItemRole = styled(TableBodyItem)`
  width: 150px;
  justify-content: center;
  padding: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
  
  @media (max-width: 440px) {
    display: none;
  }
`;

const TableBodyItemEmail = styled(TableBodyItem)`
  flex: 1;
  min-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const TableBodyItemManage = styled(TableBodyItem)`
  min-width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;

  @media (max-width: 440px) {
    min-width: 80px;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }
`;

const Button = styled.button`
  height: 32px;
  padding: 0 10px;
  border-radius: 6px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  transition: all 0.2s ease;

  @media (max-width: 440px) {
    height: 30px;
    padding: 0 8px;
    font-size: 12px;
  }
`;
const EditButton = styled(Button)`
  background-color: #186fb2;

  &:hover {
    background-color: #1558a0;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
  }
`;

const DeleteButton = styled(Button)`
  background-color: #3d3d3d;

  &:hover {
    background-color: #2a2a2a;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
  }
`;

const SearchBoxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  background-color: #f8f8f8;
  border-radius: 15px;
  padding: 20px;
  height: 90px;
  width: 100%;
`;

const ResetButton = styled.button`
  font-size: 14px;
  color: #3C3E45;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 60px;
  height: 30px;
  border-radius: 15px;
  padding: 10px 0;
  
  >svg {
    width: 20px;
    height: 20px;
    fill: #3C3E45;
  }

  &:hover {
    color: var(--primary-c);
    >svg {
      fill: var(--primary-c);
    }
  }
`;

const SearchBox = styled.form`
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  align-self: flex-end;
  height: 100%;
  width: 100%;

  >input{
    width: 100%;
    height: 100%;
    border-radius: 12px;
    border: 1px solid var(--border-c);
    padding-left: 15px;
    padding-right: 60px;
    background-color: #fff;
    font-size: 14px;
  }
`;

const SearchButton = styled.button` 
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height:35px;
  background-color: var(--primary-c);
  border-radius: 10px;
  padding: 7px 5px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: var(--primary-c-hover);
  }

  >svg {
    width: 100%;
    height: 100%;
  }
`;

export function Members() {
  const [members, setMembers] = useRecoilState(membersState);
  const [selectedMember, setSelectedMember] = useState(-1);
  const [editingMemberId, setEditingMemberId] = useState(-1);
  const [openCreateMemberModal, setOpenCreateMemberModal] = useState(false);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

  const handleWriteButtonClick = () => {
    setEditingMemberId(-1);
    setOpenCreateMemberModal(true);
  }

  const fetchMembers = useCallback(async (name = "") => {
    const data = await getMembers();
    const filteredMembers = name.trim() === "" ? data.members : data.members.filter(member => member.name.includes(name));
    setMembers(filteredMembers);
  }, [setMembers]);

  const handleOrderUp = useCallback(async () => {
    const index = members.findIndex((member) => member.id === selectedMember);
    if (index === 0) return;
    await updateMemberOrder(selectedMember, index - 1);
    fetchMembers();
  }, [selectedMember, members, fetchMembers]);

  const handleOrderDown = useCallback(async () => {
    if (selectedMember === -1) return;
    const index = members.findIndex((member) => member.id === selectedMember);
    await updateMemberOrder(selectedMember, index + 1);
    fetchMembers();
  }, [selectedMember, members, fetchMembers]);

  const handleCreateMember = useCallback(
    async (member) => {
      await createMember(member);
      fetchMembers();
      setOpenCreateMemberModal(false);
    },
    [fetchMembers]
  );

  const handleDeleteMember = useCallback(
    async (id) => {
      setSelectedMember(id);
      setIsOpenDeleteModal(true);
      // fetchMembers();
    },
    []
  );

  const handleConfirmDelete = async (isConfirmed) => {
    setIsOpenDeleteModal(false);
    if (isConfirmed) {
      try {
        await deleteMember(selectedMember);
        fetchMembers();
      } catch (error) {
        console.error("구성원 삭제 실패:", error);
      }
    }
  };

  const handleEditMember = (id) => {
    setEditingMemberId(id);
    setOpenCreateMemberModal(true);
  };

  const handleUpdateMember = useCallback(
    async (member) => {
      await updateMember(member.id, member);
      fetchMembers();
      setOpenCreateMemberModal(false);
      setEditingMemberId(-1);
    },
    [fetchMembers]
  );

  useEffect(() => {
    fetchMembers();
  }, [fetchMembers]);

  // 이름 검색
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const name = formData.get("name");
    if (name.trim() === "") {
      fetchMembers();
    } else {
      fetchMembers(name);
    }
  }

  const handleResetSearch = () => {
    fetchMembers(); // 모든 구성원 다시 불러오기
  };

  return (
    <>
      <Container>
        <ButtonContainer>
          <OrderButtonContainer>
            <SelectedMemberContainer>
              선택 항목 :
              {(() => {
                const selectedMemberName = members.find(member => member.id === selectedMember)?.name || "";
                return selectedMemberName ? (
                  <p>
                    {selectedMemberName}
                  </p>
                ) : <p></p>;
              })()}
            </SelectedMemberContainer>
            <OrderChangeContainer>
              <span>순서 변경</span>
              <OrderButtonWrapper>
                <OrderButton onClick={handleOrderUp}>
                  <UpIcon />
                </OrderButton>
                <OrderButton onClick={handleOrderDown}>
                  <DownIcon />
                </OrderButton>
              </OrderButtonWrapper>
            </OrderChangeContainer>
          </OrderButtonContainer>
          <WriteButton onClick={handleWriteButtonClick}>
            구성원 추가
          </WriteButton>

        </ButtonContainer>
        <TableContainer>
          <TableEl>
            <TableHead>
              <TableRowEl>
                <TableHeadItemNo>No.</TableHeadItemNo>
                <TableHeadItemPosition>근무지</TableHeadItemPosition>
                <TableHeadItemName>이름</TableHeadItemName>
                <TableHeadItemRole>직책</TableHeadItemRole>
                <TableHeadItemEmail>이메일</TableHeadItemEmail>
                <TableHeadItemManage>관리</TableHeadItemManage>
              </TableRowEl>
            </TableHead>
            <TableBody>
              {members.length === 0 ? (
                <TableEmptyMessage>
                  <TableBodyItem style={{ fontSize: '14px', color: '#999', padding: '30px 0' }}>
                    구성원이 존재하지 않습니다.
                  </TableBodyItem>
                </TableEmptyMessage>
              ) : (
                members.map((member, index) => (
                  <MemberRow
                    key={member.id}
                    no={index + 1}
                    {...member}
                    onEdit={handleEditMember}
                    onDelete={handleDeleteMember}
                    selectedMember={selectedMember}
                    setSelectedMember={setSelectedMember}
                  />
                )))}
            </TableBody>
          </TableEl>
        </TableContainer>
        <SearchBoxContainer>
          <ResetButton onClick={handleResetSearch}>
            <ResetIcon />
            초기화
          </ResetButton>
          <SearchBox onSubmit={handleSearchSubmit} >
            <input type="text" placeholder="이름 검색" name="name" />
            <SearchButton type="submit">
              <SearchIcon />
            </SearchButton>
          </SearchBox>
        </SearchBoxContainer>
        {
          openCreateMemberModal && (
            <MobileCreateMemberModal
              onSave={
                editingMemberId === -1 ? handleCreateMember : handleUpdateMember
              }
              onClose={() => setOpenCreateMemberModal(false)}
              memberId={editingMemberId}
              handleEdit={handleEditMember}
            />
          )
        }
        {isOpenDeleteModal && (
          <MobileConfirmDeleteModal onConfirm={handleConfirmDelete} />
        )}
      </Container>
    </>
  );
}

function MemberRow({
  onEdit,
  onDelete,
  selectedMember,
  setSelectedMember,
  ...props
}) {
  const isSelected = selectedMember === props.id;

  const handleClick = () => {
    if (isSelected) {
      setSelectedMember(-1);
    } else {
      setSelectedMember(props.id);
    }
  };

  return (
    <TableBodyRow
      onClick={handleClick}
      style={{
        ...(isSelected && { backgroundColor: "#d4e9f5", borderLeft: "3px solid #2aa4d5" }),
        cursor: "pointer",
      }}
    >
      <TableBodyItemNo>{props.no}</TableBodyItemNo>
      <TableBodyItemPosition>{props.workplace}</TableBodyItemPosition>
      <TableBodyItemName>{props.name}</TableBodyItemName>
      <TableBodyItemRole>{props.role}</TableBodyItemRole>
      <TableBodyItemEmail>{props.email}</TableBodyItemEmail>
      <TableBodyItemManage>
        <EditButton onClick={(e) => {
          e.stopPropagation();
          onEdit(props.id);
        }}>수정</EditButton>
        <DeleteButton onClick={(e) => {
          e.stopPropagation();
          onDelete(props.id);
        }}>삭제</DeleteButton>
      </TableBodyItemManage>
    </TableBodyRow>
  );
}


